'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$() {
}
export { $c_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$ as $c_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$ };
$p = $c_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$() {
}
export { $h_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$ as $h_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$ };
$h_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$.prototype = $p;
var $d_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$, "presto.TwoFactorAuthView$StoreTwoFactorAuth$", ({
  U7: 1
}));
export { $d_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$ as $d_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$ };
var $n_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$;
function $m_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$() {
  if ((!$n_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$)) {
    $n_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$ = new $c_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$();
  }
  return $n_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$;
}
export { $m_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$ as $m_Lpresto_TwoFactorAuthView$StoreTwoFactorAuth$ };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Store-Two-Factor-Auth$.js.map
